import { apiInstance } from '../../api';
export const emailRoute = 'auth/login/email';

export class AuthEmailService {
  static async loginByEmail(email, password) {
    return apiInstance.post(emailRoute, { email, password });
  }
}
